module.exports = __webpack_public_path__ + "media/src/assets/images/amenities_blue/toothbrush-8790eaee348c6d6a7486c539db199a46.svg";